// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1Fn4a","actionsCol":"EnrolledClinics_actionsCol__1Yhbi"};